import PropTypes from 'prop-types';
import React, { Component } from 'react';

import AddLink from '@/components/AddLink';
import SettingsPage from '@/components/SettingsPage';
import SettingsPageContent from '@/components/SettingsPageContent';
import SettingsPageHeader from '@/components/SettingsPageHeader';
import SettingsPageTitle from '@/components/SettingsPageTitle';
import { ROUTE_PATH as NEW_BRAND_PATH } from '@/features/brandCreatePage/consts';

import Table from './Table';

class Brands extends Component {
  static propTypes = {
    error: PropTypes.any,
    isLoading: PropTypes.bool.isRequired,
    itemsIds: PropTypes.arrayOf(PropTypes.any).isRequired,
    totalCount: PropTypes.number.isRequired,
  };

  static defaultProps = {
    error: null,
  };

  render() {
    const { error, isLoading, itemsIds, totalCount } = this.props;

    return (
      <SettingsPage>
        <SettingsPageHeader borderBottom gutterBottom={false}>
          <SettingsPageTitle>Список брендов</SettingsPageTitle>
        </SettingsPageHeader>
        <SettingsPageContent>
          <AddLink to={NEW_BRAND_PATH} />
          <Table
            error={error}
            isLoading={isLoading}
            items={itemsIds}
            totalCount={totalCount}
          />
        </SettingsPageContent>
      </SettingsPage>
    );
  }
}

export default Brands;
